import mixins from '../../mixins'

const generateUID = mixins.generateUID.methods.generateUID

export default {
  isEditMode: true,
  pageProperties: {
    pages: [
      {
        pageName: 'home',
        pageId: 1,
        sections: [
          {
            sectionId: 'a0us1n',
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            fields: [
              {
                fieldId: 'vas2fp',
                fieldType: 'multi-campaign'
              }
            ]
          }
        ]
      },
      { // PalmoliveChristmas2024 campaign
        pageName: 'PalmoliveChristmas2024',
        pageId: 28972,
        isPublic: true,
        sections: [
          {
            sectionId: 'orbg8s',
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            fields: [
              {
                fieldType: 'refresh-token',
                fieldId: 'ij3433'
              },
              {
                fieldId: 'dte-003',
                fieldType: 'dataLayer-event',
                properties: {
                  eventName: 'PageView',
                  fbEvent: 'PageView'
                }
              },
              {
                fieldType: 'key-visual',
                fieldId: '296eg1',
                properties: {
                  grid: {
                    columns: '12'
                  },
                  styles: {
                    margin: '2% 0 0 0',
                    padding: '0'
                  },
                  imageStyles: {
                    borderRadius: '16px'
                  },
                  noContainer: false,
                  addRow: true,
                  desktopImageUrl: '/assets/campaigns/PalmoliveChristmas2024/key-visual.png',
                  mobileImageUrl: '/assets/campaigns/PalmoliveChristmas2024/key-visual.png'
                }
              },
              {
                fieldType: 'participa',
                fieldId: 'acsh315',
                properties: {
                  grid: {
                    columns: '12'
                  },
                  color: '#1A202C',
                  buttonClass: 'btn-mint-green',
                  nextPage: 'PalmoliveChristmas2024/InscrieBonul',
                  campaign: 'PalmoliveChristmas2024',
                  borderColor: 'rgba(215, 199, 240, 0.5)',
                  steps: [
                    {
                      title: 'Pasul 1',
                      text: 'Cumpara produse Palmolive de min 30 lei.',
                      image: 'select'
                    },
                    {
                      title: 'Pasul 2',
                      text: 'Incarca bonul fiscal/factura',
                      image: 'receipt'
                    },
                    {
                      title: 'Pasul 3',
                      text: 'Inregistreaza-te',
                      image: 'register'
                    },
                    {
                      title: 'Pasul 4',
                      text: 'Castiga premii',
                      image: 'reward'
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      { // Upload receipt
        pageName: 'PalmoliveChristmas2024/InscrieBonul',
        pageId: 22345,
        sections: [
          {
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            sectionId: 'fu30zq',
            fields: [
              {
                fieldType: 'step-counter',
                fieldId: 'tj4j49',
                properties: {
                  activeIndex: 1,
                  colorSchema: '#006648',
                  stepShadow: '#FFFF',
                  startGradient: '#CBD5E0',
                  endGradient: 'linear-gradient(265.49deg, #008059 0%, #006647 99.55%)',
                  completedGradient: 'linear-gradient(265.49deg, #008059 0%, #006647 99.55%)',
                  steps: [
                    {
                      title: 'Cumpara produse Palmolive'
                    },
                    {
                      title: 'Incarca bonul fiscal'
                    },
                    {
                      title: 'Inregistreaza-te'
                    },
                    {
                      title: 'Castiga premii'
                    }
                  ]
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'uwxo2o',
                properties: {
                  text: '<h1>Incarca bonul fiscal/factura</h1>',
                  styles: {
                    fontFamily: 'Plus Jakarta Sans;',
                    color: '#0E1B17'
                  }
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'uwxo2o',
                properties: {
                  text: 'La acest pas, te rugăm să încarci dovada achiziționării produselor Palmolive.',
                  grid: {
                    marginTop: '15px',
                    marginBottom: '30px'
                  },
                  styles: {
                    fontWeight: '500;',
                    fontFamily: 'Plus Jakarta Sans;',
                    fontSize: '20px;',
                    color: '#00291C'
                  }
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'basg325',
                properties: {
                  text: 'Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un PDF al facturii.',
                  grid: {
                    marginBottom: '40px'
                  },
                  styles: {
                    fontWeight: '400;',
                    fontFamily: 'Plus Jakarta Sans;',
                    fontSize: '14px;',
                    lineHeight: '20px;',
                    color: '#00291C'
                  }
                }
              }
            ]
          },
          {
            sectionId: 'dyx8uv',
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            fields: [
              {
                fieldType: 'empty-bucket',
                properties: {
                  grid: {
                    columns: 0,
                    justifyContent: 'center',
                    maxWidth: '1230px'
                  },
                  fields: [
                    {
                      fieldType: 'receipt-processor',
                      fieldId: 'klvakj',
                      properties: {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        colorSchema: '#006648',
                        fileUploadColor: 'rgba(0, 0, 0, 0.5)',
                        borderColor: '#718096',
                        buttonClass: 'btn-mint-green',
                        inputBacgroundColor: '#EDF2F7',
                        grid: {
                          columns: 5,
                          alignItems: 'center',
                          justifyContent: 'center'
                        },
                        successAction: {
                          fn: 'goToPage',
                          params: 'PalmoliveChristmas2024/Inregistreaza'
                        },
                        campaignId: 'palmolivechristmas-ro-2024',
                        phrases: [
                          'Chitanta dvs. este acum incarcata si procesata.',
                          'Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.',
                          'Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou.'
                        ],
                        cornerDetectionPhrases: [
                          'Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.',
                          'Te rugam sa potrivesti bonul in cadran.',
                          'Puteti sterge informatii private cu instrumentul de stergere.'
                        ],
                        eraseColor: '#ffffff',
                        eraseSize: 12,
                        cropColor: '#F27B26',
                        cropBackground: 'rgba(0,0,0,0.6)',
                        cropTitle: 'Decupeaza',
                        eraseTitle: 'Acopera',
                        dragTitle: 'Deplaseaza imaginea',
                        zoomInTitle: 'Mareste',
                        zoomOutTitle: 'Micsoreaza',
                        selectImageTitle: 'Select an Image',
                        selectAnotherTitle: 'Select Another',
                        controlsBackground: '#561617',
                        backgroundColorBtn: 'black',
                        textColor: '#141414'
                      }
                    },
                    {
                      fieldType: 'empty-bucket',
                      properties: {
                        grid: {
                          columns: 7
                        },
                        fields: [
                          {
                            fieldType: 'receipt-information',
                            fieldId: '5mq1p6',
                            properties: {
                              grid: {
                                alignItems: 'center',
                                justifyContent: 'center',
                                columns: '12'
                              },
                              styles: {
                                textAlign: 'left'
                              },
                              color: '#006648',
                              textColor: '#0E1B17',
                              descriptionTextColor: '#00291C',
                              descriptionText: 'Nu se accepta bonuri sau facturi pliate/indoite sau scanate',
                              receiptImage: 'receipt36',
                              receiptIsSvg: true,
                              steps: [
                                {
                                  text: 'Numele magazinului',
                                  label: 'A'
                                },
                                {
                                  text: 'Produsele participante si pretul lor',
                                  label: 'B'
                                },
                                {
                                  text: 'Suma totala a bonului/facturii in LEI',
                                  label: 'C'
                                },
                                {
                                  text: 'Data si ora de pe bon sau factura',
                                  label: 'D'
                                },
                                {
                                  text: 'Numarul bonului fiscal/facturii',
                                  label: 'E'
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: 'bsbsd35',
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            fields: [
              {
                fieldType: 'receipt-image-information'
              }
            ]
          },
          {
            sectionId: 'hmgwhl',
            grid: {
              columns: 12,
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              paddingTop: '60px',
              paddingBottom: '40px'
            },
            container: true,
            buttonsWrap: true,
            fields: [
              {
                fieldType: 'button-component',
                fieldId: '16tzm1',
                properties: {
                  grid: {
                    columns: '0'
                  },
                  addClass: 'btn-link',
                  text: 'Inapoi',
                  disabled: false,
                  styles: {
                    position: 'absolute;',
                    left: 0
                  },
                  action: {
                    fn: 'goToPage',
                    params: 'PalmoliveChristmas2024'
                  }
                }
              },
              {
                fieldType: 'button-component',
                fieldId: '16tzm2',
                properties: {
                  grid: {
                    columns: '0',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  text: 'Continua',
                  addClass: 'btn-mint-green',
                  shouldCheckCrop: true,
                  requires: ['klvakj'],
                  action: {
                    fn: 'sendReceipt',
                    params: ''
                  }
                }
              }
            ]
          }
        ]
      },
      { // Register form
        pageName: 'PalmoliveChristmas2024/Inregistreaza',
        pageId: 634553232,
        sections: [
          {
            grid: {
              alignItems: 'center',
              justifyContent: 'center',
              columns: 12
            },
            container: true,
            fields: [
              {
                fieldType: 'step-counter',
                fieldId: 'tj4j49',
                properties: {
                  activeIndex: 2,
                  colorSchema: '#006648',
                  stepShadow: '#FFFF',
                  startGradient: '#CBD5E0',
                  endGradient: 'linear-gradient(265.49deg, #008059 0%, #006647 99.55%)',
                  completedGradient: 'linear-gradient(265.49deg, #008059 0%, #006647 99.55%)',
                  steps: [
                    {
                      title: 'Cumpara produse Palmolive'
                    },
                    {
                      title: 'Incarca bonul fiscal'
                    },
                    {
                      title: 'Inregistreaza-te'
                    },
                    {
                      title: 'Castiga premii'
                    }
                  ]
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'fckzg7',
                properties: {
                  text: '<h1>Formular de inscriere</h1>',
                  styles: {
                    color: '#0E1B17'
                  }
                }
              }
            ]
          },
          {
            sectionId: 'ci88zt',
            grid: {
              alignItems: 'center',
              justifyContent: 'center',
              columns: 4,
              marginTop: '40px'
            },
            container: true,
            fields: [
              {
                fieldType: 'form-component',
                fieldId: 'j765n4b',
                properties: {
                  styles: {
                    margin: '0',
                    justifyContent: 'center',
                    '--maxWidth': '545px',
                    '--backgroundColor': '#EDF2F7'
                  },
                  grid: {
                    alignItems: 'center',
                    columns: '0',
                    justifyContent: 'center'
                  },
                  requires: ['1'],
                  successAction: {
                    fn: 'goToPage',
                    params: 'PalmoliveChristmas2024/Multumim'
                  },
                  endpoint: '/register',
                  // gReCaptcha3: true,
                  // multiFactorAuth: true,
                  fields: [
                    {
                      fieldId: 'b4baqs',
                      fieldType: 'text-input',
                      properties: {
                        name: 'surname',
                        autocomplete: 'no',
                        label: 'Prenume',
                        placeholder: 'Introdu prenumele',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|onlyLetters',
                        grid: {
                          alignItems: 'center',
                          justifyContent: 'center',
                          columns: 12
                        },
                        styles: {
                          marginTop: '30px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'gofije',
                      fieldType: 'text-input',
                      properties: {
                        name: 'name',
                        autocomplete: 'no',
                        label: 'Nume',
                        placeholder: 'Introdu numele',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|onlyLetters',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'h7kzf9',
                      fieldType: 'text-input',
                      properties: {
                        name: 'email',
                        label: 'E-mail',
                        placeholder: 'Introdu e-mailul',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|email',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'vake42c',
                      fieldType: 'text-input',
                      properties: {
                        name: 'mobile',
                        label: 'Numar de telefon',
                        placeholder: 'Introdu numarul de telefon',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|phoneNumber',
                        grid: {
                          columns: 12
                        },
                        autocomplete: 'nope',
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'ko3h1sz',
                      fieldType: 'paragraph',
                      properties: {
                        text: '<b>Atentie!</b> In cazul introducerii unei adrese de e-mail gresite, in daca cazul in care esti declarat castigator, nu vei primi premiul castigat, conform Articolelor 7.3.3/8.2/11.2 din Regulamentul acestei campanii.',
                        grid: {
                          columns: '12',
                          marginTop: '35px'
                        },
                        classes: ['disclaimer'],
                        styles: {
                          color: '#2E2E2E !important'
                        }
                      }
                    },
                    {
                      fieldType: 'google-recaptcha-v2'
                    },
                    {
                      fieldId: 'wgc3j7',
                      fieldType: 'checkbox',
                      properties: {
                        name: 'terms',
                        validation: {
                          required: {
                            allowFalse: false
                          }
                        },
                        validationName: 'Termenii si conditiile sunt necesare',
                        grid: {
                          columns: '12',
                          paddingTop: '10px'
                        },
                        styles: {
                          marginTop: '30px',
                          '--color': '#2E2E2E',
                          '--checkedCheckbox':
                            'url(/assets/icons/form/checked_checkbox.svg)',
                          '--uncheckedCheckbox':
                            'url(/assets/icons/form/unchecked_checkbox.svg)'
                        },
                        label: `Confirm ca am peste 18 ani. Confirm <a href="/files/PalmoliveChristmas2024Regulament.pdf" target="_blank"><u>termenii si conditiile</u></a> si <a href="https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy" target="_blank"><u>politica de confidentialitate</u></a></div>.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: 'yh453gg4',
            grid: {
              columns: 12,
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              paddingTop: '60px',
              paddingBottom: '120px'
            },
            container: true,
            buttonsWrap: true,
            fields: [
              {
                fieldType: 'button-component',
                fieldId: '16tzm1',
                properties: {
                  grid: {
                    columns: '0'
                  },
                  addClass: 'btn-link',
                  text: 'Inapoi',
                  disabled: false,
                  styles: {
                    position: 'absolute;',
                    left: 0
                  },
                  action: {
                    fn: 'goToPage',
                    params: 'PalmoliveChristmas2024/InscrieBonul'
                  }
                }
              },
              {
                fieldType: 'button-component',
                fieldId: '16tzm2',
                properties: {
                  grid: {
                    columns: '0',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  text: 'TRIMITE',
                  disabled: false,
                  addClass: 'btn-mint-green',
                  action: {
                    fn: 'sendForm',
                    params: 'j765n4b'
                  }
                }
              }
            ]
          }
        ]
      },
      { // Thank you
        pageName: 'PalmoliveChristmas2024/Multumim',
        pageId: 99800,
        noContainer: true,
        sections: [
          {
            grid: {
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            fields: [
              {
                fieldType: 'thank-you',
                fieldId: 'gjd10',
                properties: {
                  campaign: 'PalmoliveChristmas2024',
                  campaignName: 'Palmolive - Spiridușul vestimentației tale de sărbători',
                  haveActivator: false,
                  borderColor: '#CBD5E0',
                  textColor: '#00291C',
                  textBeforeReferenceColor: '#828282',
                  referenceColor: '#006648',
                  copyImageSrc: '/assets/icons/copy7.svg'
                }
              }
            ]
          }
        ]
      },
      { // Thank you after reupload
        pageName: 'PalmoliveChristmas2024/Multumesc',
        pageId: 99801,
        noContainer: true,
        sections: [
          {
            grid: {
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            fields: [
              {
                fieldType: 'thank-you',
                fieldId: 'gjd10',
                properties: {
                  campaign: 'PalmoliveChristmas2024',
                  campaignName: 'Palmolive - Spiridușul vestimentației tale de sărbători',
                  haveActivator: false,
                  borderColor: '#CBD5E0',
                  textColor: '#00291C',
                  textBeforeReferenceColor: '#828282',
                  referenceColor: '#006648',
                  copyImageSrc: '/assets/icons/copy7.svg'
                }
              }
            ]
          }
        ]
      },
      { // Error page
        pageName: 'PalmoliveChristmas2024/error-page',
        pageId: 10424,
        isPublic: true,
        sections: [
          {
            grid: {
              alignItems: 'center',
              justifyContent: 'center',
              columns: 12
            },
            container: true,
            fields: [
              {
                fieldType: 'error-page',
                fieldId: 'gjd10',
                properties: {
                  grid: {
                    columns: '12'
                  },
                  showLottie: true,
                  buttonClass: 'btn-mint-green',
                  LottieUrl: '/assets/Lottie/error-Lottie-blue-bear-red-boat.txt'
                }
              }
            ]
          }
        ]
      },
      { // expired page
        pageName: 'PalmoliveChristmas2024/expired-page',
        pageId: 104224,
        isPublic: true,
        sections: [
          {
            grid: {
              alignItems: 'center',
              justifyContent: 'center',
              columns: 12
            },
            container: true,
            fields: [
              {
                fieldType: 'expired-page',
                fieldId: 'gjd101',
                properties: {
                  grid: {
                    columns: '12'
                  },
                  showLottie: true,
                  buttonClass: 'btn-mint-green',
                  LottieUrl: '/assets/Lottie/expired-link-Lottie.txt'
                }
              }
            ]
          }
        ]
      },
      { // Faq
        pageName: 'PalmoliveChristmas2024/IntrebariFrecvente',
        isPublic: true,
        sections: [
          {
            grid: {
              alignItems: 'center',
              justifyContent: 'center',
              columns: 12,
              marginBottom: '50px'
            },
            fields: [
              {
                fieldType: 'pdf-viewer',
                fieldId: 'vabd69',
                properties: {
                  grid: {
                    alignItems: 'center',
                    justifyContent: 'center',
                    columns: '12'
                  },
                  link: 'https://jolt-assets.s3.eu-central-1.amazonaws.com/template/promocolgatepalmolive-ro/PalmoliveChristmas2024/faq.pdf'
                }
              }
            ]
          }
        ]
      },
      { // Castigatori
        pageName: 'PalmoliveChristmas2024/castigatori',
        isPublic: true,
        sections: [
          {
            grid: {
              alignItems: 'center',
              justifyContent: 'center',
              columns: 12,
              marginBottom: '50px'
            },
            fields: [
              {
                fieldType: 'text-list',
                fieldId: 'a6prst',
                properties: {
                  colorSchema: '#000000',
                  title: 'Castigatori',
                  ordered: false,
                  items: [
                    {
                      title: ``,
                      text: `
                      <ul>
                        <li>Gosea Alexandra Ștefania - 3FS5JQZL2R</li>
                        <li>Marciu Siminica - 3BCE8EVCSQ</li>
                        <li>Bucur Adrian - S2WKMEMMFJ</li>
                        <li>Nica Robert Ion - 34ZB1VVZJG</li>
                        <li>Olteanu Daniel - 69TH9VJ9YQ</li>
                        <li>Miclius Andrei Danut - UTKIWLC47N</li>
                        <li>Constandache Petrusa Romana  - 8DS2KKG55L</li>
                        <li>Nica Andrei Ionut - 5QZYK2TX3X</li>
                        <li>Berian Melinda - H35Z97PL9D</li>
                        <li>Moraru Liviu Aurel - FEYPJQI4G3</li>
                        <li>Razvan Jescu - HEFK3EZZ51</li>
                        <li>Babeanu Ionuț Eduard - 8YPXFXMJUV</li>
                        <li>Miron Maria - 1EQ19M7F2N</li>
                        <li>Terecoasa Alexandra - M4J2DHYGRM</li>
                        <li>Mares Alexandra Claudia - TAGK4T4XES</li>
                        <li>Ungureanu Daniel - CFUUKR9B63</li>
                        <li>Zmaranda Daniel - BLW53G5IHQ</li>
                        <li>Leanca Ioana - NVF39B9KW9</li>
                        <li>Teleanu Elisabeta - UMY2BRP5AI</li>
                        <li>Maestrenco Camelia - JBQF18FRXN</li>
                        <li>Marciu Adriana - 5L3B4Q12NW</li>
                        <li>Ungureanu Liliana - ZTD343W8IW</li>
                        <li>Pircalabelu Vasile-Adrian - YFA1JPMBXY</li>
                        <li>Stefan Stoica - J9FUDJ54VW</li>
                        <li>Lahman Ioan - X27E4K99WJ</li>
                        <li>Neculcea Florin - 12G5BX924E</li>
                        <li>Pircalabelu Ana Maria - RVJTP9GI5N</li>
                        <li>Ciocirlan Mihai - SVGL9ECZ5E</li>
                        <li>Colcea Iulian - 2ZZGUZJ7YP</li>
                        <li>Radu Mihaela Iuliana - NHF6XMY4ZM</li>
                      </ul>`
                    },
                    {
                      title: `Data publicarii 23.01.2025`,
                      text: ``
                    }
                  ],
                  grid: {
                    alignItems: 'center',
                    justifyContent: 'center',
                    columns: '8'
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner form page
        pageName: 'PalmoliveChristmas2024/WinnerPage',
        isPublic: true,
        pageId: 6345513,
        sections: [
          {
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            headerWrap: true,
            sectionId: 'basb782',
            fields: [
              {
                fieldType: 'query-string-to-state',
                fieldId: 'vasv24',
                properties: {
                  variables: [
                    {
                      query: 'customerToken',
                      state: 'customerToken'
                    }
                  ]
                }
              },
              {
                fieldType: 'query-string-to-state',
                fieldId: 'uwxo2o1',
                properties: {
                  variables: [
                    {
                      query: 'receiptToken',
                      state: 'receiptToken'
                    }
                  ]
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'uwxo2o',
                properties: {
                  text: "<h1 style=' color= #141414; '>Formular pentru Castigator</h1>"
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'uwxo2o',
                properties: {
                  text: 'Completeaza-ti adresa in formularul de mai jos pentru a-ti putea trimite premiul',
                  grid: {
                    marginTop: '15px',
                    marginBottom: '30px'
                  },
                  styles: {
                    fontWeight: '500;',
                    fontFamily: 'Plus Jakarta Sans;',
                    fontSize: '20px;',
                    color: '#141414'
                  }
                }
              }
            ]
          },
          {
            sectionId: 'ci88zt',
            grid: {
              alignItems: 'center',
              justifyContent: 'center',
              columns: 4,
              marginTop: '50px'
            },
            container: true,
            fields: [
              {
                fieldType: 'form-component',
                fieldId: 'j765n4b',
                properties: {
                  styles: {
                    margin: '0',
                    justifyContent: 'center',
                    '--backgroundColor': '#F0EEF1'
                  },
                  grid: {
                    alignItems: 'center',
                    columns: '0',
                    justifyContent: 'center'
                  },
                  requires: ['1'],
                  successAction: {
                    fn: 'goToPage',
                    params: 'PalmoliveChristmas2024/WinnerThankYou'
                  },
                  endpoint: '/winnerRegister',
                  fields: [
                    {
                      fieldId: 'b4baqs',
                      fieldType: 'text-input',
                      properties: {
                        name: 'surname',
                        autocomplete: 'no',
                        label: 'Prenume',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|onlyLetters',
                        grid: {
                          alignItems: 'center',
                          justifyContent: 'center',
                          columns: 12
                        },
                        styles: {
                          marginTop: '30px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'gofije',
                      fieldType: 'text-input',
                      properties: {
                        name: 'name',
                        autocomplete: 'no',
                        label: 'Nume',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|onlyLetters',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'h7kzf9',
                      fieldType: 'text-input',
                      properties: {
                        name: 'email',
                        label: 'E-mail',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|email',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'vake42c',
                      fieldType: 'text-input',
                      properties: {
                        name: 'mobile',
                        label: 'Numar de telefon',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|phoneNumber',
                        grid: {
                          columns: 12
                        },
                        autocomplete: 'nope',
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'h7kzf8',
                      fieldType: 'text-input',
                      properties: {
                        name: 'address',
                        label: 'Adresa',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'requiredAdress|adress',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'ko3h1sz',
                      fieldType: 'paragraph',
                      properties: {
                        text: '*strada, numar, bloc, scara, apartament',
                        grid: {
                          columns: '12',
                          marginTop: '20px;',
                          marginBottom: '20px'
                        },
                        classes: ['disclaimer'],
                        styles: {
                          color: '#2E2E2E !important'
                        }
                      }
                    }
                  ],
                  extraFields: [
                    {
                      fieldId: 'bdsb632',
                      fieldType: 'select-input-county',
                      properties: {
                        name: 'judet',
                        label: 'Judet',
                        placeholder: 'Judet',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'requiredJudet',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '30px',
                          borderColor: '#ADB5BD'
                        },
                        autocomplete: 'nope'
                      }
                    },
                    {
                      fieldId: 'bask257',
                      fieldType: 'select-input-city',
                      properties: {
                        name: 'localitate',
                        label: 'Localitate',
                        placeholder: 'Localitate',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'requiredLocal',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        },
                        autocomplete: 'nope'
                      }
                    },
                    {
                      fieldId: 'acasg235',
                      fieldType: 'text-input',
                      properties: {
                        name: 'postal',
                        label: 'Cod postal',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'integer|length:6',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        },
                        autocomplete: 'nope',
                        disablePaste: true
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: 'yh453gg4',
            grid: {
              columns: 12,
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              paddingTop: '60px',
              paddingBottom: '130px'
            },
            container: true,
            styles: {
              justifyContent: 'center'
            },
            fields: [
              {
                fieldType: 'button-component',
                fieldId: '16tzm2',
                properties: {
                  grid: {
                    columns: '0',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  text: 'TRIMITE',
                  disabled: false,
                  addClass: 'btn-mint-green',
                  action: {
                    fn: 'sendForm',
                    params: 'j765n4b'
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner CNP form page
        pageName: 'PalmoliveChristmas2024/WinnerPageCNP',
        isPublic: true,
        pageId: 634553,
        sections: [
          {
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            headerWrap: true,
            sectionId: 'basb782',
            fields: [
              {
                fieldType: 'query-string-to-state',
                fieldId: 'vasv24',
                properties: {
                  variables: [
                    {
                      query: 'customerToken',
                      state: 'customerToken'
                    }
                  ]
                }
              },
              {
                fieldType: 'query-string-to-state',
                fieldId: 'uwxo2o1',
                properties: {
                  variables: [
                    {
                      query: 'receiptToken',
                      state: 'receiptToken'
                    }
                  ]
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'uwxo2o',
                properties: {
                  text: "<h1 style=' color= #141414; '>Formular pentru Castigator</h1>"
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'uwxo2o',
                properties: {
                  text: 'Completeaza-ti adresa in formularul de mai jos pentru a-ti putea trimite premiul',
                  grid: {
                    marginTop: '15px',
                    marginBottom: '30px'
                  },
                  styles: {
                    fontWeight: '500;',
                    fontFamily: 'Plus Jakarta Sans;',
                    fontSize: '20px;',
                    color: '#141414'
                  }
                }
              }
            ]
          },
          {
            sectionId: 'ci88zt',
            grid: {
              alignItems: 'center',
              justifyContent: 'center',
              columns: 4,
              marginTop: '50px'
            },
            container: true,
            fields: [
              {
                fieldType: 'form-component',
                fieldId: 'j765n4b',
                properties: {
                  styles: {
                    margin: '0',
                    justifyContent: 'center',
                    '--backgroundColor': '#F0EEF1'
                  },
                  grid: {
                    alignItems: 'center',
                    columns: '0',
                    justifyContent: 'center'
                  },
                  requires: ['1'],
                  successAction: {
                    fn: 'goToPage',
                    params: 'PalmoliveChristmas2024/WinnerThankYou'
                  },
                  endpoint: '/winnerRegister',
                  fields: [
                    {
                      fieldId: 'b4baqs',
                      fieldType: 'text-input',
                      properties: {
                        name: 'surname',
                        autocomplete: 'no',
                        label: 'Prenume',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|onlyLetters',
                        grid: {
                          alignItems: 'center',
                          justifyContent: 'center',
                          columns: 12
                        },
                        styles: {
                          marginTop: '30px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'gofije',
                      fieldType: 'text-input',
                      properties: {
                        name: 'name',
                        autocomplete: 'no',
                        label: 'Nume',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|onlyLetters',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'h7kzf9',
                      fieldType: 'text-input',
                      properties: {
                        name: 'email',
                        label: 'E-mail',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|email',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'vake42c',
                      fieldType: 'text-input',
                      properties: {
                        name: 'mobile',
                        label: 'Numar de telefon',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|phoneNumber',
                        grid: {
                          columns: 12
                        },
                        autocomplete: 'nope',
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'h7kzf8',
                      fieldType: 'text-input',
                      properties: {
                        name: 'address',
                        label: 'Adresa',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'requiredAdress|adress',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'ko3h1sz',
                      fieldType: 'paragraph',
                      properties: {
                        text: '*strada, numar, bloc, scara, apartament',
                        grid: {
                          columns: '12',
                          marginTop: '20px;',
                          marginBottom: '20px'
                        },
                        classes: ['disclaimer'],
                        styles: {
                          color: '#2E2E2E !important'
                        }
                      }
                    }
                  ],
                  extraFields: [
                    {
                      fieldId: 'bdsb632',
                      fieldType: 'select-input-county',
                      properties: {
                        name: 'judet',
                        label: 'Judet',
                        placeholder: 'Judet',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'requiredJudet',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '30px',
                          borderColor: '#ADB5BD'
                        },
                        autocomplete: 'nope'
                      }
                    },
                    {
                      fieldId: 'bask257',
                      fieldType: 'select-input-city',
                      properties: {
                        name: 'localitate',
                        label: 'Localitate',
                        placeholder: 'Localitate',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'requiredLocal',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        },
                        autocomplete: 'nope'
                      }
                    },
                    {
                      fieldId: 'acasg235',
                      fieldType: 'text-input',
                      properties: {
                        name: 'postal',
                        label: 'Cod postal',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'integer|length:6',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        },
                        autocomplete: 'nope',
                        disablePaste: true
                      }
                    },
                    {
                      fieldId: 'bsdy4362',
                      fieldType: 'text-input',
                      properties: {
                        name: 'cnp',
                        autocomplete: 'no',
                        label: 'CNP',
                        placeholder: '',
                        text: '',
                        validation: 'required|integer|length:13',
                        color: '#2E2E2E',
                        grid: {
                          alignItems: 'center;',
                          justifyContent: 'center;',
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'bsadbsd325',
                      fieldType: 'checkbox',
                      properties: {
                        name: 'cnpConfirm',
                        validation: {
                          required: {
                            allowFalse: false
                          }
                        },
                        validationName: 'terms',
                        grid: {
                          columns: '12',
                          paddingTop: '10px'
                        },
                        styles: {
                          marginTop: '30px',
                          '--color': '#2E2E2E',
                          '--checkedCheckbox':
                            'url(/assets/icons/form/checked_checkbox.svg)',
                          '--uncheckedCheckbox':
                            'url(/assets/icons/form/unchecked_checkbox.svg)'
                        },
                        label: `Declar ca acest CNP imi apartine, cunoscand faptul ca orice declaratie falsa este sanctionata conform legii penale romane.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: 'yh453gg4',
            grid: {
              columns: 12,
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              paddingTop: '60px',
              paddingBottom: '130px'
            },
            container: true,
            styles: {
              justifyContent: 'center'
            },
            fields: [
              {
                fieldType: 'button-component',
                fieldId: '16tzm2',
                properties: {
                  grid: {
                    columns: '0',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  text: 'TRIMITE',
                  disabled: false,
                  addClass: 'btn-mint-green',
                  action: {
                    fn: 'sendForm',
                    params: 'j765n4b'
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner thank you
        pageName: 'PalmoliveChristmas2024/WinnerThankYou',
        pageId: 99830,
        noContainer: true,
        sections: [
          {
            grid: {
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            fields: [
              {
                fieldType: 'thank-you-winner',
                fieldId: 'gjd10',
                properties: {
                  campaign: 'PalmoliveChristmas2024',
                  campaignName: 'COLGATE WHITENING SELGROS',
                  haveActivator: false,
                  textColor: '#141414'
                }
              }
            ]
          }
        ]
      },
      { // Receipt reupload
        pageName: 'PalmoliveChristmas2024/receipt-reupload',
        isPublic: true,
        pageId: 32,
        sections: [
          {
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            headerWrap: true,
            sectionId: 'fu30zq',
            fields: [
              {
                fieldType: 'query-string-to-state',
                fieldId: 'uwxo2o1',
                properties: {
                  variables: [
                    {
                      query: 'referenceNumber',
                      state: 'formData'
                    }
                  ]
                }
              },
              { // 72 Hours check
                fieldType: 'checkReceiptToken',
                fieldID: 'dksnfsdkjf',
                properties: {
                  grid: { columns: 12 }
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'uwxo2o',
                properties: {
                  text: '<h1>Te rugam sa incarci din nou bonul fiscal/factura</h1>',
                  styles: {
                    color: '#0E1B17'
                  }
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'uwxo2o',
                properties: {
                  text: 'Bonul fiscal/factura incarcat/a anterior nu ne este complet/a sau este ilizibil.',
                  grid: {
                    marginTop: '15px',
                    marginBottom: '30px'
                  },
                  styles: {
                    fontWeight: '500;',
                    fontFamily: 'Plus Jakarta Sans;',
                    fontSize: '20px;',
                    color: '#00291C;'
                  }
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'basg325',
                properties: {
                  text:
                    'Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un PDF al facturii',
                  grid: {
                    marginBottom: '40px'
                  },
                  styles: {
                    fontWeight: '400;',
                    fontFamily: 'Plus Jakarta Sans;',
                    fontSize: '14px;',
                    lineHeight: '20px;',
                    color: '#00291C;'
                  }
                }
              }
            ]
          },
          {
            sectionId: 'dyx8uv',
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            fields: [
              {
                fieldType: 'empty-bucket',
                properties: {
                  grid: {
                    columns: 0,
                    justifyContent: 'center',
                    maxWidth: '1230px'
                  },
                  fields: [
                    {
                      fieldType: 'receipt-processor',
                      fieldId: 'klvakj',
                      properties: {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        colorSchema: '#006648',
                        fileUploadColor: 'rgba(0, 0, 0, 0.5)',
                        borderColor: '#718096',
                        buttonClass: 'btn-mint-green',
                        inputBacgroundColor: '#EDF2F7',
                        grid: {
                          columns: 5,
                          alignItems: 'center',
                          justifyContent: 'center'
                        },
                        successAction: {
                          fn: 'goToPage',
                          params: 'PalmoliveChristmas2024/Multumesc'
                        },
                        campaignId: 'palmolivechristmas-ro-2024',
                        phrases: [
                          'Chitanta dvs. este acum incarcata si procesata.',
                          'Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.',
                          'Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou.'
                        ],
                        cornerDetectionPhrases: [
                          'Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.',
                          'Te rugam sa potrivesti bonul in cadran.',
                          'Puteti sterge informatii private cu instrumentul de stergere.'
                        ],
                        eraseColor: '#ffffff',
                        eraseSize: 12,
                        cropColor: '#F27B26',
                        cropBackground: 'rgba(0,0,0,0.6)',
                        cropTitle: 'Decupeaza',
                        eraseTitle: 'Acopera',
                        dragTitle: 'Deplaseaza imaginea',
                        zoomInTitle: 'Mareste',
                        zoomOutTitle: 'Micsoreaza',
                        selectImageTitle: 'Select an Image',
                        selectAnotherTitle: 'Select Another',
                        controlsBackground: '#561617',
                        backgroundColorBtn: 'black',
                        reUpload: true,
                        tokenName: 'token'
                      }
                    },
                    {
                      fieldType: 'empty-bucket',
                      properties: {
                        grid: {
                          columns: 7
                        },
                        fields: [
                          {
                            fieldType: 'receipt-information',
                            fieldId: '5mq1p6',
                            properties: {
                              grid: {
                                alignItems: 'center',
                                justifyContent: 'center',
                                columns: '12'
                              },
                              styles: {
                                textAlign: 'left'
                              },
                              color: '#006648',
                              textColor: '#141414',
                              descriptionTextColor: '#2E2E2E',
                              descriptionText: 'Nu se accepta bonuri sau facturi pliate/indoite sau scanate',
                              receiptImage: 'receipt36',
                              receiptIsSvg: true,
                              steps: [
                                {
                                  text: 'Numele magazinului',
                                  label: 'A'
                                },
                                {
                                  text: 'Produsele participante si pretul lor',
                                  label: 'B'
                                },
                                {
                                  text: 'Suma totala a bonului/facturii in LEI',
                                  label: 'C'
                                },
                                {
                                  text: 'Data si ora de pe bon sau factura',
                                  label: 'D'
                                },
                                {
                                  text: 'Numarul bonului fiscal/facturii',
                                  label: 'E'
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: 'bsbsd35',
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            fields: [
              {
                fieldType: 'receipt-image-information'
              }
            ]
          },
          {
            sectionId: 'hmgwhl',
            grid: {
              columns: 12,
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              paddingTop: '60px',
              paddingBottom: '40px'
            },
            container: true,
            styles: {
              justifyContent: 'center'
            },
            fields: [
              {
                fieldType: 'button-component',
                fieldId: '16tzm2',
                properties: {
                  grid: {
                    columns: '0',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  text: 'Trimite',
                  addClass: 'btn-mint-green',
                  shouldCheckCrop: true,
                  requires: ['klvakj'],
                  action: {
                    fn: 'sendReceipt',
                    params: ''
                  }
                }
              }
            ]
          }
        ]
      },
      { // Product reupload
        pageName: 'PalmoliveChristmas2024/product-reupload',
        isPublic: true,
        pageId: 1282452,
        sections: [
          {
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            headerWrap: true,
            sectionId: 'fu30zq',
            fields: [
              {
                fieldType: 'query-string-to-state',
                fieldId: 'uwxo2o1',
                properties: {
                  variables: [
                    {
                      query: 'referenceNumber',
                      state: 'formData'
                    }
                  ]
                }
              },
              { // 72 Hours check
                fieldType: 'checkReceiptToken',
                fieldID: 'dksnfsdkjf',
                properties: {
                  grid: { columns: 12 }
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'uwxo2o',
                properties: {
                  text: '<h1>Incarca o poza a produsului</h1>',
                  styles: {
                    color: '#0E1B17'
                  }
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'basv352',
                properties: {
                  text: 'Incarca o poza cu produsele participante la campanie',
                  grid: {
                    marginTop: '15px',
                    marginBottom: '30px'
                  },
                  styles: {
                    fontWeight: '500;',
                    fontFamily: 'Plus Jakarta Sans;',
                    fontSize: '20px;',
                    color: '#00291C;'
                  }
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'basg325',
                properties: {
                  text: 'Doar fisiere JPG, PNG, si PDF sunt acceptate. Fisierul poate avea maxim 16MB.',
                  grid: {
                    marginBottom: '40px'
                  },
                  styles: {
                    fontWeight: '400;',
                    fontFamily: 'Plus Jakarta Sans;',
                    fontSize: '14px;',
                    lineHeight: '20px;',
                    color: '#00291C;'
                  }
                }
              }
            ]
          },
          {
            sectionId: 'dyx8uv',
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            fields: [
              {
                fieldType: 'empty-bucket',
                properties: {
                  grid: {
                    columns: 0,
                    justifyContent: 'center',
                    maxWidth: '1230px'
                  },
                  fields: [
                    {
                      fieldType: 'product-upload',
                      fieldId: 'ase123v',
                      properties: {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca poza</span><br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Fisierul poate avea maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        colorSchema: '#DB0811',
                        borderColor: '#561617',
                        buttonClass: 'btn-mint-green',
                        inputBacgroundColor: '#EDF2F7',
                        grid: {
                          columns: 5,
                          alignItems: 'center',
                          justifyContent: 'center'
                        },
                        endpoint: '/uploadProductPhoto',
                        successAction: {
                          fn: 'goToPage',
                          params: 'PalmoliveChristmas2024/Multumesc'
                        },
                        phrases: [
                          'Chitanta dvs. este acum incarcata si procesata.',
                          'Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.',
                          'Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou.'
                        ],
                        cornerDetectionPhrases: [
                          'Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.',
                          'Te rugam sa potrivesti bonul in cadran.',
                          'Puteti sterge informatii private cu instrumentul de stergere.'
                        ],
                        reUpload: true
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: 'hmgwhl',
            grid: {
              columns: 12,
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              marginTop: '60px',
              marginBottom: '30px'
            },
            container: true,
            styles: {
              justifyContent: 'center'
            },
            fields: [
              {
                fieldType: 'button-component',
                fieldId: '16tzm2',
                properties: {
                  grid: {
                    columns: '0',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  text: 'Trimite',
                  addClass: 'btn-mint-green',
                  shouldCheckCrop: false,
                  requires: ['ase123v'],
                  action: {
                    fn: 'sendProductPhotos',
                    params: ''
                  }
                }
              }
            ]
          }
        ]
      }
    ],
    header: {
      fieldType: 'navbar',
      fieldId: 'cbx34t',
      properties: {
        dataLayer: {
          GTM: {
            Sitelocale: 'ro-ro',
            SiteTouchpoint: '',
            SiteCountry: 'RO',
            SiteBrand: '',
            SiteLanguage: 'RO',
            SitePlatform: '',
            SiteEnvironment: 'Prod',
            SiteHost: 'CTL',
            SiteTechnicalAgency: 'Justsnap',
            SiteStatus: 'Live',
            GoogleAnalyticsLocal: 'UA-15274544-47',
            GoogleAnalyticsBrand: '',
            GoogleAnalyticsSiteSpeedSampleRate: 'high',
            GoogleAnalyticsAllowLinker: 'true',
            GoogleAnalyticsLinkerDomains: '',
            GoogleAnalyticsEnableOptimizely: 'false',
            GoogleAnalyticsConsentRequired: 'true',
            GoogleAnalyticsOptimizeContainerID: '',
            GoogleAnalyticsReportingView: '',
            GoogleReCaptcha: 'true',
            SiteLocalContainer: '',
            FacebookRemarketingID: '270266680523196',
            ConsentOverlay: 'OneTrust',
            ConsentOverlayID: 'htmllang/7bfbeeed-fe9a-477f-99c7-84ca45614eb3',
            SitePrivacyProtection: 'GDPR'
          },
          GTM_CODE: 'GTM-TG4C5LV'
        },
        // "neustar": { //   "url": "https://aa.agkn.com/adscores/g.js?sid=9212300878"
        // },
        // "facebookPixel": { //   init: "270266680523196"
        // },
        title: '',
        color: '#FAF6EE',
        grid: {
          columns: 12
        },
        logo: {
          imageSource: '/assets/logo.svg',
          width: 345,
          alternateText: 'Brand Logo',
          paddingTop: '30px'
        },
        fields: [
          // {
          //   "fieldId": "bsdb35",
          //   "fieldType": "anchor",
          //   "properties": {
          //     "text": "Castigatori",
          //     "url": "/PalmoliveChristmas2024/castigatori",
          //     "target": "_blank",
          //     "cssClass": "nav-link",
          //     "styles": {
          //       "color": "#050E23",
          //       "fontSize": "18px",
          //       "fontWeight": "400"
          //     }
          //   }
          // },
          {
            fieldId: 'ikz8vc',
            fieldType: 'anchor',
            properties: {
              text: 'Regulament',
              url: '/files/PalmoliveChristmas2024Regulament.pdf',
              target: '_blank',
              cssClass: 'nav-link',
              styles: {
                color: '#050E23',
                fontSize: '18px',
                fontWeight: '400'
              }
            }
          },
          {
            fieldId: 'slnmdk',
            fieldType: 'anchor',
            properties: {
              text: 'Intrebari frecvente',
              url: '/PalmoliveChristmas2024/IntrebariFrecvente',
              target: '_blank',
              cssClass: 'nav-link',
              styles: {
                color: '#050E23',
                fontSize: '18px',
                fontWeight: '400'
              }
            }
          }
        ],
        showLine: false,
        meta: [
          { name: 'title', content: 'Protex' },
          {
            name: 'description',
            content: `Protex`
          },
          {
            name: 'keywords',
            content: `Protex`
          }
        ]
      }
    },
    footer: {
      fieldType: 'footer-component',
      fieldId: '4tfbzz',
      properties: {
        links: [{ name: '', link: '' }],
        supportLinks: [
          {
            name: 'Confidentialitate',
            link: 'https://www.jnjconsumer.ro/politica-confidentialitate'
          }
        ],
        styles: {
          color: '#000'
        },
        fields: [
          {
            fieldId: 'ikz8vc1',
            fieldType: 'anchor',
            properties: {
              text: 'Termeni si conditii',
              url: '/files/PalmoliveChristmas2024Regulament.pdf',
              target: '_blank',
              styles: {
                color: '#40454A'
              }
            }
          },
          {
            fieldId: 'slnmdk2',
            fieldType: 'anchor',
            properties: {
              text: ' Politica de confidentialitate',
              url: 'https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy',
              target: '_blank',
              styles: {
                color: '#40454A'
              }
            }
          }
        ]
      }
    },
    campaignId: 'palmolivechristmas-ro-2024',
    url: 'PalmoliveChristmas2024',
    name: 'palmolivechristmas-ro-2024'
  },
  pageBuilder: {
    selectedField: {
      sectionId: '',
      fieldId: generateUID()
    }
  },
  componentStatus: {},
  modal: {
    type: 'error',
    message: 'An error has occurred',
    isActive: false
  },
  customerToken: '',
  receiptToken: '',
  receiptImage: '',
  campaignId: 'palmolivechristmas-ro-2024',
  campaignURLName: 'PalmoliveChristmas2024',
  formData: new FormData(),
  campaignStartDate: '2023-10-01',
  campaignEndDate: '2024-11-30',
  showNavLinks: false,
  excludedPages: ['home'],
  cities: [],
  customerMobile: ''
}
